import { TextBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface BusinessEntityNameProps {
    required?: boolean;
    onValidationEvent: (isValid: boolean) => void;
}

export const BusinessEntityName: React.FC<BusinessEntityNameProps> = ({ required = false, onValidationEvent }) => {
    const isMobile = isMobileScreen();
    const label = 'Business Entity Name';
    const value = useBrokerNewReferralStore((s) => s.referral.businessEntityName);
    const setValue = useBrokerNewReferralStore((s) => s.set_businessEntityName);
    return (
        <>
            <TextBox
                id='businessEntityNameTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : '450px'}
                onValidationEvent={onValidationEvent}
            />
        </>
    );
};
